import React from "react";
import styled from "styled-components";

function Font({ fontSize, weight, color, bold, children, ...props }) {
  return (
    <FontStyled $fontSize={transformIfPixel(fontSize)} $bold={bold} $weight={weight} $color={color} {...props}>
      {children}
    </FontStyled>
  );
}

export default Font;

const isNumber = (n) => !isNaN(Number(n));
const transformIfPixel = (n) => (isNumber(n) ? +n + "px" : n);

const FontStyled = styled.span`
  font-size: ${({ $fontSize }) => ($fontSize ? `${$fontSize}` : "inherit")};
  ${({ $bold }) => ($bold ? "font-weight: bold;" : null)}
  ${({ $weight }) => ($weight ? `font-weight: ${$weight};` : null)}
  ${({ $color }) => ($color ? `color: ${$color};` : null)};
`;
